module.exports = __webpack_public_path__ + "static/img/doItemBg1.d5407ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/doItemBg1.png
// module id = 6s+A
// module chunks = 1